module.exports = __webpack_public_path__ + "static/media/cleango1.80876f79.webp";